import React from 'react';
import { Form, FormInstance } from 'antd';

import { FormInput } from '../../components/forms/FormInput';
import { FormTextArea } from '../../components/forms/FormTextArea';
import { StyledColumn } from '../../components/StyledColumn';

export type ClientDataFormProps = {
  form?: FormInstance;
};

export const ClientDataForm: React.FC<ClientDataFormProps> = ({ form }) => {
  return (
    <div>
      <Form form={form} style={{ flexGrow: '1' }} layout="vertical" colon={false}>
        <StyledColumn gap="0.3rem">
          <FormInput name="name" label="Name" required />

          <FormTextArea name="description" label="Description" />
        </StyledColumn>
      </Form>
    </div>
  );
};
